import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MdbTableDirective } from 'mdb-angular-ui-kit/table';
// import { ModalAppsComponent } from 'src/app/components/crud/modal-apps/modal-apps.component';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { Logs } from 'src/app/models/interfaces.model';
import { environment } from 'src/app/environments/environments';
import * as moment from 'moment';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent {
  @ViewChild('table') table!: MdbTableDirective<Logs>;

  // modalRef: MdbModalRef<ModalAppsComponent> | null = null;

  loading = true;
  loadingFull = false;

  headers = [
    { label: 'Fecha Creación Orden', field: 'CREATION_DATE_ORDER', disableSort: false },
    { label: 'N° Doc', field: 'NUM_DOC', disableSort: false },
    { label: 'Proveedor', field: 'CLIENTE', disableSort: false },
    { label: 'Email', field: 'EMAIL', disableSort: false },
    { label: 'Card Code', field: 'CARD_CODE', disableSort: false },
    { label: 'Contactos', field: 'CONTACTOS', disableSort: false },
    { label: 'Genero PDF', field: 'GENERO_PDF', disableSort: false },
    { label: 'Estado Envío Email', field: 'STATUS_ENVIO_EMAIL', disableSort: false },
    { label: 'Usuario Generó OC', field: 'USUARIO_GENERO_OC', disableSort: false },
    // { label: 'EXCEPCION', field: 'EXCEPCION', disableSort: false },
    { label: 'Fecha creación Log', field: 'CREATED_AT', disableSort: false },
    { label: 'N° Solicitud', field: 'NUMERO_SOLICITUD', disableSort: false },
    { label: 'Solicitante', field: 'SOLICITANTE', disableSort: false },
    { label: 'Email Solicitante', field: 'SOLICITANTE_EMAIL', disableSort: false },
    // { label: 'Activo', field: 'ACTIVE', disableSort: false },
  ];

  dataSource: Logs[] = [];

  constructor(private modalService: MdbModalService, private _http: HttpClient, private crudService: GenericCrudService<Logs>) { }

  async ngOnInit(): Promise<void> {
    await this.getAllLogs();
  }

  search(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.table.search(searchTerm);
  }

  async getAllLogs(): Promise<void> {
    const body = new FormData();
    body.append('action', "SELECT");
    body.append('table_name', "LOG_OC");
    body.append('id_company', localStorage.getItem('IdCompany') ?? '');

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.GetLogs).subscribe((data: any) => {
        if (data && data.status === 1 && data.data) {
          console.log("data.data: ", data.data); 
          this.dataSource = data.data.map((entry: Logs) => {
            let status = entry.STATUS_ENVIO_EMAIL
            switch (status) {
              case "0":
                status = "Sin actividad"
                break;
              case "1":
                status = "Listo para enviar"
              break;
              case "2":
                status = "Enviado"
              break;
              case "3":
                status = "Con Error";
              break;
              default:
                status = "Sin Información"
                break;
            }
            return {
              ID: entry.ID,
              CREATION_DATE_ORDER: moment(entry.CREATION_DATE_ORDER).format('DD-MM-YYYY'),
              NUM_DOC: entry.NUM_DOC,
              CLIENTE: entry.CLIENTE,
              EMAIL: entry.EMAIL,
              CARD_CODE: entry.CARD_CODE,
              CONTACTOS: entry.CONTACTOS,
              GENERO_PDF: entry.GENERO_PDF,
              STATUS_ENVIO_EMAIL: status,
              USUARIO_GENERO_OC: entry.USUARIO_GENERO_OC,
              // EXCEPCION: entry.EXCEPCION,
              CREATED_AT: moment(entry.CREATED_AT).format('DD-MM-YYYY HH:mm:ss'),
              ACTIVE: entry.ACTIVE,
              NUMERO_SOLICITUD: entry.NUMERO_SOLICITUD,
              SOLICITANTE: entry.SOLICITANTE,
              SOLICITANTE_EMAIL: entry.SOLICITANTE_EMAIL,
            };
          });
          this.loading = false;
        } else {
          console.error('Error: No se pudo obtener la data de logs.');
        }
      }, error => {
        console.error('Error: ', error);
      });
    });
  }
}
